import { requestJson } from "../api/apiClient";

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value != null && value !== "") params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export async function fetchDealerCoverageDashboard(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/coverage/dashboard${buildQuery(filters)}`);
}

export async function fetchDealerCoverageSummary(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/coverage/summary${buildQuery(filters)}`);
}

export async function fetchDealerCoverageSourceTypes(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/coverage/source-types${buildQuery(filters)}`);
}

export async function fetchDealerCoverageCities() {
  return requestJson("/api/admin/automotive/dealers/coverage/cities");
}

export async function fetchDealerCoverageBrands() {
  return requestJson("/api/admin/automotive/dealers/coverage/brands");
}

export async function fetchDealerCoverageReviewQueue(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/coverage/review-queue${buildQuery(filters)}`);
}

export async function fetchDealerCoverageExcluded(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/coverage/excluded${buildQuery(filters)}`);
}

export async function fetchDealerTopDirectCandidates() {
  return requestJson("/api/admin/automotive/dealers/coverage/top-direct-candidates");
}

export async function fetchDealers(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers${buildQuery(filters)}`);
}

export async function fetchDealerDetail(dealerProfileId) {
  return requestJson(
    `/api/admin/automotive/dealers/${encodeURIComponent(dealerProfileId)}`
  );
}

export async function exportDealerNetwork100() {
  return requestJson("/api/admin/automotive/dealers/coverage/export-100", {
    method: "POST",
  });
}

export async function fetchDealerCoverageExportJson() {
  return requestJson("/api/admin/automotive/dealers/coverage/export-json");
}

export function dealerReviewQueueCsvUrl(filters = {}) {
  return `/api/admin/automotive/dealers/coverage/review-queue${buildQuery({ ...filters, format: "csv" })}`;
}

export function dealerExcludedCsvUrl(filters = {}) {
  return `/api/admin/automotive/dealers/coverage/excluded${buildQuery({ ...filters, format: "csv" })}`;
}

export async function fetchDealerGovernanceDashboard(filters = {}) {
  return requestJson(`/api/admin/automotive/dealers/governance/dashboard${buildQuery(filters)}`);
}

export async function runDealerGovernanceChecks(options = {}) {
  return requestJson(`/api/admin/automotive/dealers/governance/run${buildQuery(options)}`, {
    method: "POST",
    body: JSON.stringify(options),
  });
}

export async function patchDealerGovernanceFinding(findingId, payload) {
  return requestJson(
    `/api/admin/automotive/dealers/governance/findings/${encodeURIComponent(findingId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
}
